export interface Store<T> {
	setItem: (item: T) => void;
	getItem: (defaultValue?: T | undefined) => T;
	clear: () => void;
}

class StorageStatic {
	getStore<T, U>(key: string, serialize: (value: T) => U, deserialize: (data: U) => T, version?: number): Store<T> {
		const versionedKey = `${key}-${version ?? 0}`;
		return {
			setItem: (item: T) => {
				try {
					localStorage.setItem(versionedKey, JSON.stringify(serialize(item)));
				} catch (e) {
					console.warn(e);
				}
			},
			getItem: (defaultValue?: T): T => {
				try {
					const item = localStorage.getItem(versionedKey);
					if (item === null) {
						return defaultValue as T;
					}
					return deserialize(JSON.parse(item) as U);
				} catch (e) {
					console.warn(e);
					return defaultValue as T;
				}
			},
			clear: () => localStorage.removeItem(versionedKey),
		};
	}
}

export const storage = new StorageStatic();
